export default function carouselWidget(editor) {
  editor.DomComponents.addType('eb-carousel', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-carousel'
    },
    model: {
      defaults: {
        name: 'Carousel',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-carousel' },
        style: {
          'position': 'relative',
          'overflow': 'hidden',
          'border-radius': '8px',
        },
        components: `
          <style>
            .eb-carousel-track { display: flex; overflow-x: auto; scroll-snap-type: x mandatory; scroll-behavior: smooth; -webkit-overflow-scrolling: touch; scrollbar-width: none; }
            .eb-carousel-track::-webkit-scrollbar { display: none; }
            .eb-carousel-slide { flex: 0 0 100%; scroll-snap-align: start; min-height: 300px; display: flex; align-items: center; justify-content: center; position: relative; }
            .eb-carousel-nav { position: absolute; bottom: 15px; left: 50%; transform: translateX(-50%); display: flex; gap: 8px; z-index: 2; }
            .eb-carousel-dot { width: 10px; height: 10px; border-radius: 50%; background: rgba(255,255,255,0.5); border: none; cursor: pointer; padding: 0; }
            .eb-carousel-dot.active { background: #fff; }
            .eb-carousel-btn { position: absolute; top: 50%; transform: translateY(-50%); background: rgba(255,255,255,0.9); border: none; width: 40px; height: 40px; border-radius: 50%; font-size: 18px; cursor: pointer; z-index: 2; display: flex; align-items: center; justify-content: center; color: #333; }
            .eb-carousel-prev { left: 10px; }
            .eb-carousel-next { right: 10px; }
          </style>
          <div class="eb-carousel-wrap" style="position:relative;">
            <div class="eb-carousel-track">
              <div class="eb-carousel-slide" style="background:linear-gradient(135deg,#667eea,#764ba2);">
                <div style="text-align:center;color:#fff;padding:40px;">
                  <h2 style="font-size:32px;font-weight:700;margin:0 0 10px;">Slide One</h2>
                  <p style="font-size:16px;opacity:0.9;margin:0;">Your first slide content here</p>
                </div>
              </div>
              <div class="eb-carousel-slide" style="background:linear-gradient(135deg,#f093fb,#f5576c);">
                <div style="text-align:center;color:#fff;padding:40px;">
                  <h2 style="font-size:32px;font-weight:700;margin:0 0 10px;">Slide Two</h2>
                  <p style="font-size:16px;opacity:0.9;margin:0;">Your second slide content here</p>
                </div>
              </div>
              <div class="eb-carousel-slide" style="background:linear-gradient(135deg,#4facfe,#00f2fe);">
                <div style="text-align:center;color:#fff;padding:40px;">
                  <h2 style="font-size:32px;font-weight:700;margin:0 0 10px;">Slide Three</h2>
                  <p style="font-size:16px;opacity:0.9;margin:0;">Your third slide content here</p>
                </div>
              </div>
            </div>
            <button class="eb-carousel-btn eb-carousel-prev" aria-label="Previous">&#8249;</button>
            <button class="eb-carousel-btn eb-carousel-next" aria-label="Next">&#8250;</button>
            <div class="eb-carousel-nav">
              <button class="eb-carousel-dot active" data-slide="0"></button>
              <button class="eb-carousel-dot" data-slide="1"></button>
              <button class="eb-carousel-dot" data-slide="2"></button>
            </div>
          </div>
        `,
        traits: [
          { type: 'checkbox', name: 'data-autoplay', label: 'Autoplay' },
          { type: 'number', name: 'data-interval', label: 'Interval (ms)', default: 5000 },
        ],
      },
      toHTML() {
        const attrs = this.getAttributes()
        const autoplay = attrs['data-autoplay'] === 'true'
        const interval = attrs['data-interval'] || '5000'
        const style = this.getStyle()
        const styleStr = Object.entries(style).map(([k, v]) => `${k}:${v}`).join(';')
        const inner = this.getInnerHTML()
        return `<div data-gjs-type="eb-carousel" style="${styleStr}">
          ${inner}
          <script>
          (function(){var w=document.currentScript.parentElement.querySelector('.eb-carousel-wrap');if(!w)return;var track=w.querySelector('.eb-carousel-track');var slides=w.querySelectorAll('.eb-carousel-slide');var dots=w.querySelectorAll('.eb-carousel-dot');var prev=w.querySelector('.eb-carousel-prev');var next=w.querySelector('.eb-carousel-next');var cur=0;function go(i){cur=((i%slides.length)+slides.length)%slides.length;track.scrollTo({left:slides[cur].offsetLeft,behavior:'smooth'});dots.forEach(function(d,j){d.classList.toggle('active',j===cur);});}if(prev)prev.onclick=function(){go(cur-1);};if(next)next.onclick=function(){go(cur+1);};dots.forEach(function(d,j){d.onclick=function(){go(j);};});${autoplay ? `setInterval(function(){go(cur+1);},${interval});` : ''}})();
          <\\/script>
        </div>`
      },
    },
  })

  editor.BlockManager.add('eb-carousel', {
    label: 'Carousel',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M2,6H6V18H2V6M7,19H17V5H7V19M8,6H16V18H8V6M18,6H22V18H18V6Z"/></svg>',
    content: { type: 'eb-carousel' },
  })
}
